/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Save_Group_Before_UsersInputs */



/**
* | output |
* | --- |
* | "Please save the group first before adding users." |
*
* @param {Team_Manager_Save_Group_Before_UsersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_group_before_users = /** @type {((inputs?: Team_Manager_Save_Group_Before_UsersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_Group_Before_UsersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez d’abord enregistrer le groupe avant d’ajouter des utilisateurs.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte speichern Sie zuerst die Gruppe, bevor Sie Benutzer hinzufügen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si prega di salvare prima il gruppo prima di aggiungere utenti.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перед добавлением пользователей сначала сохраните группу.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guarde el grupo primero antes de agregar usuarios.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请先保存群组，然后再添加用户。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーを追加する前に、まずグループを保存してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया उपयोगकर्ताओं को जोड़ने से पहले समूह को सहेज लें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, salve o grupo antes de adicionar usuários.")
	return /** @type {LocalizedString} */ ("Please save the group first before adding users.")
});